/*
 * Jira Ticket:
 * Created Date: Wed, 13th May 2020, 09:58:07 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { AutocompleteInput } from 'react-admin';

// NOTE: This input is to be used in Organisation Reference type fields where we need to remove the
// principal organisation (the org you are currently viewing) but display its contractors

const SelectInputWithoutPrincipalOrg = props => {
  let { choices, label, organisationId, ...rest } = props;
  const choicesWithoutPrincipalOrg = choices.filter(organisation => {
    return organisation.id !== organisationId;
  });
  return (
    <AutocompleteInput
      source="organisationId"
      choices={choicesWithoutPrincipalOrg}
      optionText="name"
      label={label}
      shouldRenderSuggestions={val => {
        return val.trim().length > 2;
      }}
      {...rest}
    />
  );
};

export default SelectInputWithoutPrincipalOrg;
